/* eslint-disable import-x/export */
import type { OperationData } from 'core/types/makeMutationHook'

import {
  addCaseAssociation as addCaseAssociationBase,
  createInteractionNote as createInteractionNoteBase,
  loanRefundsCancel as loanRefundsCancelBase,
  removeCaseAssociation as removeCaseAssociationBase,
  updateInteractionNote as updateInteractionNoteBase,
  listUnterminatedTasks as listUnterminatedTasksBase,
  internalEmployeesGet as internalEmployeesGetBase,
  employeesGet as employeesGetBase,
  internalEmployeeGetById as internalEmployeeGetByIdBase,
  employeeGetById as employeeGetByIdBase,
  listCaseType as listCaseTypeBase,
  getEventsExternal as getEventsExternalBase,
  AddCaseAssociationResponse,
  AddCaseAssociationKey,
  AddCaseAssociationVariables,
  RemoveCaseAssociationResponse,
  RemoveCaseAssociationKey,
  RemoveCaseAssociationVariables,
  UpdateInteractionNoteResponse,
  UpdateInteractionNoteKey,
  UpdateInteractionNoteVariables,
  CreateInteractionNoteResponse,
  CreateInteractionNoteKey,
  CreateInteractionNoteVariables,
  ListUnterminatedTasksKey,
  ListUnterminatedTasksVariables,
  LoanRefundsCancelResponse,
  LoanRefundsCancelKey,
  LoanRefundsCancelVariables,
  EmployeesGetKey,
  EmployeesGetVariables,
  InternalEmployeesGetKey,
  InternalEmployeesGetVariables,
  EmployeeGetByIdKey,
  EmployeeGetByIdVariables,
  InternalEmployeeGetByIdKey,
  InternalEmployeeGetByIdVariables,
  GetEventsExternalVariables,
  GetEventsExternalKey,
  GetEventsExternalResponse,
  ListCaseTypeResponse,
  ListCaseTypeKey,
  ListCaseTypeVariables,
} from './generated/operations'
import { SingletonResponse } from './generated/responses/types'
import { ResponseEmployee, ResponseEmployeesPaging, NewPaginator, Task, Employee, EventPublic, CaseType } from './types'

export * from './generated/operations'

export const addCaseAssociation = addCaseAssociationBase as OperationData<
  AddCaseAssociationResponse,
  AddCaseAssociationKey,
  AddCaseAssociationVariables & { interactionId?: string }
>

export const removeCaseAssociation = removeCaseAssociationBase as OperationData<
  RemoveCaseAssociationResponse,
  RemoveCaseAssociationKey,
  RemoveCaseAssociationVariables & { interactionId?: string }
>

export const updateInteractionNote = updateInteractionNoteBase as OperationData<
  UpdateInteractionNoteResponse,
  UpdateInteractionNoteKey,
  UpdateInteractionNoteVariables & { personId: string | undefined }
>

export const createInteractionNote = createInteractionNoteBase as OperationData<
  CreateInteractionNoteResponse,
  CreateInteractionNoteKey,
  CreateInteractionNoteVariables & { personId: string | undefined }
>

export const listUnterminatedTasks = listUnterminatedTasksBase as OperationData<
  NewPaginator & { data?: Array<Task> },
  ListUnterminatedTasksKey,
  ListUnterminatedTasksVariables
>

export const listCaseType = listCaseTypeBase as OperationData<
  Omit<ListCaseTypeResponse, 'data'> & { data?: Array<CaseType> },
  ListCaseTypeKey,
  ListCaseTypeVariables
>

export const loanRefundsCancel = loanRefundsCancelBase as OperationData<
  LoanRefundsCancelResponse,
  LoanRefundsCancelKey,
  LoanRefundsCancelVariables & { companyId: string | undefined }
>

export const employeesGet = employeesGetBase as OperationData<
  Omit<ResponseEmployee, 'data'> & { data?: Array<Employee> },
  EmployeesGetKey,
  EmployeesGetVariables
>

export const internalEmployeesGet = internalEmployeesGetBase as OperationData<
  Omit<ResponseEmployeesPaging, 'data'> & { data?: Array<Employee> },
  InternalEmployeesGetKey,
  InternalEmployeesGetVariables
>

export const employeeGetById = employeeGetByIdBase as OperationData<
  Omit<ResponseEmployee, 'data'> & { data?: Employee },
  EmployeeGetByIdKey,
  EmployeeGetByIdVariables
>

export const internalEmployeeGetById = internalEmployeeGetByIdBase as OperationData<
  Omit<ResponseEmployee, 'data'> & { data?: Employee },
  InternalEmployeeGetByIdKey,
  InternalEmployeeGetByIdVariables
>

export type InternalEmployeeGetByIdResponse = SingletonResponse & {
  data?: Employee
}

// TODO sc-34744
export type ListUnterminatedTasksResponse = NewPaginator & {
  data?: Array<Task>
}

// TODO sc-41270
export const getEventsExternal = getEventsExternalBase as OperationData<
  Omit<GetEventsExternalResponse, 'data'> & { data?: Array<EventPublic> },
  GetEventsExternalKey,
  GetEventsExternalVariables
>
